import axiosInstance, { ApiKeys, getApiUrl } from '@cp/src/utils/ApiHelper';
import { ICreateProduct, ICreateTiemline } from './interfaces';
import {
  setAttributes,
  setExperiments,
  setProducts,
  setSegments,
  setTenants,
  setTimelines,
  setStrategies,
  setTriggers
} from './reducer';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { set } from 'react-hook-form';
import { Dispatch } from '@reduxjs/toolkit';
import { Tenant } from '@cp/pages/Paramount/types';

export const createProduct = (data: ICreateProduct, tenant: Tenant, successCb: () => void) => {
  const url = getApiUrl(ApiKeys.PARAMOUNT_CREATE_PRODUCT);
  axiosInstance
    .post(url, data, {
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey
      }
    })
    .then(response => {
      toast.success('Product created successfully');
      successCb();
    })
    .catch(error => {
      toast.error('Product creation failed');
    });
};
export const getProductsByTenant = (tenant: Tenant) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.PRODUCTS_BY_TENATREFID);
  axiosInstance
    .get(url, {
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey
      },
      params: { tenantReferenceId: tenant.referenceId }
    })
    .then(response => {
      dispatch(setProducts(response.data));
    });
};
export const createTimeline = (data: ICreateTiemline, tenant: Tenant, successCb: () => void) => {
  const url = getApiUrl(ApiKeys.PARAMOUNT_TIMELINE);
  axiosInstance
    .post(url, data, {
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey,
        'x-navi-principal': 'test'
      }
    })
    .then(response => {
      toast.success('Timeline created successfully');
      successCb();
    })
    .catch(error => {
      toast.error('Timeline creation failed');
    });
};
export const getAllTenants = (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.PARAMOUNT_GET_ALL_TENANTS);
  axiosInstance
    .get(url, { headers: { 'X-NAVI-CORRELATION-ID': 'test' } })
    .then(response => dispatch(setTenants(response.data)));
};

export const getTimelinesByTenant = (tenant: Tenant) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_TIMELINES_BY_TENANTREFID);
  axiosInstance
    .get(url, {
      params: { tenantReferenceId: tenant.referenceId },
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey
      }
    })
    .then(response => {
      dispatch(setTimelines(response.data));
    });
};

export const getSegmentsByTenant = (tenant: Tenant) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_SEGMENTS_BY_TENANTREFID);
  axiosInstance
    .get(url, {
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey
      },
      params: { tenantReferenceId: tenant.referenceId }
    })
    .then(response => {
      dispatch(setSegments(response.data));
    });
};

export const getAttributesByTenant = (tenant: Tenant) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_ATTRIBUTES_BY_TENANTREFID);
  axiosInstance
    .get(url, {
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey
      },
      params: { tenantReferenceId: tenant.referenceId }
    })
    .then(response => {
      dispatch(setAttributes(response.data));
    });
};

export const getStrategiesByTenant = (tenant: Tenant) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_STRATEGIES_BY_TENANTREFID);
  axiosInstance
    .get(url, {
      params: { tenantReferenceId: tenant.referenceId },
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey
      }
    })
    .then(response => {
      dispatch(setStrategies(response.data));
    });
};

export const getExperimentsByTenant = (tenant: Tenant) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_EXPERIMENTS_BY_TENANTREFID);
  axiosInstance
    .get(url, {
      params: { tenantReferenceId: tenant.referenceId },
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey
      }
    })
    .then(response => {
      dispatch(setExperiments(response.data));
    });
};

export const getTriggersByTenant = (tenant: Tenant) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_TRIGGERS_BY_TENANTREFID);
  axiosInstance
    .get(url, {
      params: { tenantReferenceId: tenant.referenceId },
      headers: {
        'X-Tenant-Ref-Id': tenant.referenceId,
        'X-NAVI-CORRELATION-ID': 'test',
        'x-api-key': tenant.apiKey
      }
    })
    .then(response => {
      dispatch(setTriggers(response.data));
    });
};

export const validate = ({ data, type, tenant }: { data: any; type: string; tenant: Tenant }) => {
  const url = getApiUrl(ApiKeys.PARAMOUNT_VALIDATION);
  axiosInstance
    .post(
      url,
      { data: data },
      {
        params: { type, tenantReferenceId: tenant.referenceId },
        headers: {
          'X-Tenant-Ref-Id': tenant.referenceId,
          'X-NAVI-CORRELATION-ID': 'test',
          'x-api-key': tenant.apiKey
        }
      }
    )
    .then(response => {
      toast.success('Validation successful');
    })
    .catch(error => {
      toast.error('Validation failed');
    });
};

export const creation = ({
  data,
  type,
  tenant
}: {
  data: string;
  type: string;
  tenant: Tenant;
}) => {
  const url = getApiUrl(ApiKeys.PARAMOUNT_CREATION);
  axiosInstance
    .post(
      url,
      { data: data },
      {
        params: { type, tenantReferenceId: tenant.referenceId },
        headers: {
          'X-Tenant-Ref-Id': tenant.referenceId,
          'X-NAVI-CORRELATION-ID': 'test',
          'x-api-key': tenant.apiKey
        }
      }
    )
    .then(response => {
      toast.success('Created successful');
    })
    .catch(error => {
      toast.error('Creation failed');
    });
};

export const getTemplate = (tenant: Tenant, templateType: string) => {
  const url = getApiUrl(ApiKeys.PARAMOUNT_FETCH_TEMPLATE);
  return axiosInstance.get(url, {
    headers: {
      'X-Tenant-Ref-Id': tenant.referenceId,
      'X-NAVI-CORRELATION-ID': 'test',
      'x-api-key': tenant.apiKey
    },
    params: {
      templateName: templateType
    }
  });
};
